import React, { useState } from 'react';
import classNames from 'classnames';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { ICascaderShortcutProps, IShortcutItem } from '@intelligence/components/Form/type';
import { getShowLabel } from '../../../utils';

export default function ShortCut(props: ICascaderShortcutProps) {
  // console.log(props);
  const { options, onClick } = props;
  const { formatMessage } = useIntlExtend();

  const handleClick = (item: IShortcutItem) => {
    onClick && onClick instanceof Function && onClick(item);
  };

  return (
    <>
      <div className="dbi-cascader-checkbox-title">
        {getShowLabel({ label: 'shortcut', labelKey: 'dbi_shortcut'}, formatMessage, 'label')}
      </div>
      <div className="dbi-cascader-shortcut">
        {options?.map((item: IShortcutItem) => (
          <div
            onClick={() => handleClick(item)}
            className={classNames('dbi-cascader-shortcut-item', {
              'dbi-cascader-shortcut-item-active': item.isChecked
            })}
            key={item.value}
          >
            {getShowLabel(item, formatMessage, 'label')}
          </div>
        ))}
      </div>
    </>
  );
}
